// this is an autogenerated file from DesignSystem/TasksFilters/Location/Content/Locations/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_TasksFilters_Location_Content_Locations($board_id: [uuid!]!) {
  session_user_locations(order_by: { name: asc }) {
    id
    _id
    name
  }

  tasks_boards(where: { id: { _in: $board_id } }) {
    id
    metadata(path: "locations")
  }
}

`